<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <h5 class="mb-0 text-primary"><i class="fa fa-group text-primary"></i> Category</h5>
          </div>
          <hr />
          <div class="row g-3">
            <div class="col-md-6">
              <label for="inputName" class="form-label">Name<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <input type="text" class="form-control form-control-sm" v-model="Obj.Name" />
            </div>
            <div class="col-md-12 text-md-center text-end mt-2">
            <button class="btn btn-sm btn-darknavy me-1" @click="save">
              <i class="fa fa-save"></i> Save
            </button>
            <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fas fa-times-circle  me-1"></i> Cancel</button>
          </div>
          </div>
          <ul v-if="errors.length" class="text-danger ps-3">
            <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
          </ul>
          <div class="row">
            <div class="col-md-12 table-responsive mt-2">
               <div class="progress mb-0 progress-sm" v-if="progress1!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress1" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress1 + '%' }"></div>
      </div>
              <DataTable v-if="progress1==0" :columns="columns" :rows="rows" :pageSize="10"   :actions="{ edit: handleEdit, delete: handleDelete }" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <h5 class="mb-0 text-primary">  <i class="fas fa-hands-helping text-primary me-1"></i> Religion</h5>
          </div>
          <hr />
          <div class="row g-3">
            <div class="col-md-6">
              <label for="inputName" class="form-label">Name<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <input type="text" class="form-control form-control-sm" v-model="regObj.Name" />
            </div>
            <div class="col-md-12 text-md-center text-end mt-1">
              <button class="btn btn-sm  btn-darknavy me-1" @click="regSave()">
                <i class="fa fa-save"></i> Save
              </button>
               <button type="button" class="btn btn-sm btn-soft-dark" @click="regreset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
            </div>
          </div>
          <ul v-if="error1.length" class="text-danger ps-3">
              <li v-for="(err1, index) in error1" :key="index">{{ err1 }}</li>
            </ul>
          <div class="row">
            <div class="col-md-12 table-responsive mt-2">
          <div class="progress mb-0 progress-sm" v-if="progress2!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress2" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress2 + '%' }"></div>
          </div>
               <DataTable v-if="progress2==0" :columns="regcolumns" :rows="regrows" :pageSize="10"   :actions="{ edit: handleEdit, delete: handleDelete }" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
 const Obj=ref( { Name: "", });
  const regObj=ref({  name: "" });
  const msgObj=ref({ msg: "", role: "", show: false });
  const delObj=ref({});
  const errors=ref({});
  const error1=ref({});
  const columns=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name' },
]);
const regcolumns = ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name' },
]);
const rows=ref([])
const regrows = ref([])
const progress1 = ref(0)
const progress2 = ref(0)
let progressInterval1 = null
let progressInterval2 = null
const loadCategoryData = async () => {
  progress1.value = 1
  progressInterval1 = setInterval(() => {
    progress1.value += 1
    if (progress1.value >= 100) progress1.value = 0
  }, 100)
  await api.get('/Category/all').then(CategoryList => {
        rows.value = CategoryList.data.map((item, i) => ({ ...item, Sno: i + 1, record:'Category' }))
        progress1.value = 0
        clearInterval(progressInterval1)
  })
}
  const loadReligionData = async () => {
  progress2.value = 1
  progressInterval2 = setInterval(() => {
    progress2.value += 1
    if (progress2.value >= 100) progress2.value = 0
  }, 100)
  await api.get('/religion/all').then(ReligionList => {
        regrows.value = ReligionList.data.map((item, i) => ({ ...item, Sno: i + 1, record:'Religion' }))
        progress2.value = 0
        clearInterval(progressInterval2)
  })
}

const handleEdit = (row) => {
  if(row.record == 'Category') {
    Obj.value = { ...row }
  } else {
    regObj.value = {...row}
  }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const save = async () => {
  const fields = {
    Name: { value: Obj.value.Name, validators: [isRequired], },
  };
  errors.value = validateForm(fields);
  const idx = rows.value.findIndex(item => item.Name.toLowerCase() === Obj.value.Name.toLowerCase() && item._id !== Obj.value._id);
if (idx >= 0) {
   msgObj.value = { msg: "Category Name already exists.", role: "danger", show: true, };
  return ;
}
  if (Object.keys(errors.value).length === 0) {
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/Category${url}`, Obj.value)
      .then(() => {
        loadCategoryData();
        reset();
        msgObj.value = { msg: `Category ${msg} Successfuly`, role: "success", show: true, };
      })
      .catch((error) => { console.log(error); });
  }
}
const regSave = async () => {
  const fields = {
    Name: { value: regObj.value.Name, validators: [isRequired], },
  };
  error1.value = validateForm(fields);
  const idx = regrows.value.findIndex(item => item.Name.toLowerCase() === regObj.value.Name.toLowerCase() && item._id !== regObj.value._id);
if (idx >= 0) {
   msgObj.value = { msg: "Religion Name already exists.", role: "danger", show: true, };
  return ;
}
  if (Object.keys(error1.value).length === 0) {
    const { url, method, msg } = curdStatus(regObj.value);
    await api[method](`/religion${url}`, regObj.value)
      .then((response) => {
        loadReligionData();
        regreset();
        msgObj.value = { msg: `Religion ${msg} Successfuly`, role: "success", show: true, };
        console.log(response);
      })
      .catch((error) => { console.log(error); });
  }
}
const reset = () => {
  Obj.value = { Name: "", };
  msgObj.value = { msg: "", role: "", show: false };
  errors.value={};
}
const regreset = () => {
  regObj.value = { Name: "" };
  msgObj.value = { msg: "", role: "", show: false };
   error1.value={};
}
const delRecord = async () => {
  const delName = delObj.value.record;
  await api.delete(`/${delObj.value.record}/${delObj.value._id}`)
    .then(() => {
      if(delName == 'Category') {
          loadCategoryData();
      }else {
        loadReligionData();
      }
      delObj.value={};
      msgObj.value = { msg: `${delName} Deleted Successfuly.`, role: "danger", show: true, };
    });
}
onMounted(() => { loadCategoryData(); loadReligionData(); })
</script>

